function of(promise) {
    return Promise.resolve(promise)
        .then((r) => [r])
        .catch((e) => {
        if (e === undefined || e === null) {
            return [e, new Error('Rejection with empty value')];
        }
        return [undefined, e];
    });
}

export default of;
export { of };
